<template>
  <div>
    <el-row class="container">
      <el-col :span="isMobileLayout ? 24 : $mq === 'lg' ? 10 : 12">
        <h2 class="title text-uppercase text-left pt-60">
          {{ $i18n.t("shoppingCart.shoppingCartView.title") }}
        </h2>
        <el-image
          v-if="isMobileLayout"
          class="image__dimension mt-15"
          :src="images.shoppingCartEmpty.src"
          :fit="'fill'"
        />
        <div class="shopping-cart--paragraph">
          <div
            :class="[
              'empty-cart text-left',
              isMobileLayout ? 'mt-18' : 'mt-15',
            ]"
          >
            <span>
              {{ $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar1Span1") }}
            </span>
            <span
              class="para-link"
              v-if="countryCode === 'QC'"
              @click="goTo('/products?inventory=STORE_MTL')"
            >
              <span>{{
                $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar1Span2")
              }}</span>
            </span>
            <!-- <span
              v-if="countryCode === 'QC'"
              class="para-link"
              @click="goTo('/products?inventory=STORE_QC')"
            >
              <span>{{
                $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar1Span7")
              }}</span>
            </span> -->
            <span
              v-else
              class="para-link"
              @click="goTo('/products?inventory=STORE_TORONTO')"
            >
              <span>{{
                $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar1Span8")
              }}</span>
            </span>
            <span>{{
              $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar1Span3")
            }}</span>
            <span class="para-link" @click="goTo('/products?type=VIN')">
              <span>{{
                $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar1Span4")
              }}</span>
            </span>
            <span>{{
              $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar1Span5")
            }}</span>
          </div>
          <div class="paragraph1 text-left  empty-cart mt-20">
            <span>{{
              $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar2Span1")
            }}</span>

            <span>{{
              $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar2Span2")
            }}</span>
            <span>{{
              $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar2Span3")
            }}</span>

            <span>{{
              $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar2Span4")
            }}</span>
            <span>{{
              $i18n.t("shoppingCart.shoppingCartEmptyView.infoPar2Span5")
            }}</span>
          </div>
        </div>
      </el-col>
      <el-col :span="isMobileLayout ? 0 : 12">
        <el-image
          v-if="!isMobileLayout"
          class="image__dimension"
          :src="images.shoppingCartEmpty.src"
          :fit="'fill'"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import layoutUtils from "@/utils/layout-utils";
import imgDefault from "@/assets/images/shopping-cart/empty-cart.png";
import goTo from "../../mixins/goTo";
export default {
  mixins: [goTo],
  components: {},
  data() {
    return {
      images: {
        shoppingCartEmpty: {
          src: imgDefault,
        },
      },
      // Normalized the same way the writers do (add-to-cart.vue, product.vue),
      // so the `cartProducts<code>` key read here matches the one written.
      countryCode: localStorage.getItem("countryCode") === 'ON' ? 'ON' : 'QC',
    };
  },
  computed: {
    title() {
      return this.$i18n.t("shoppingCart.shoppingCartView.title");
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
  mounted() {
    this.$root.$on("chancountryCode", (countryCode) => {
      this.countryCode = countryCode;
    });
    if (['/shopping-cart', '/shopping-cart-empty'].includes(this.$route.path))  {
      // The old condition was `getProducts || getProducts.length != 0 || getProducts != null`:
      // with `||` the null check came last, so a missing/"null" key dereferenced
      // `.length` on null and threw out of the mounted hook.
      let getProducts = null;
      try {
        getProducts = JSON.parse(localStorage.getItem("cartProducts" + this.countryCode));
      } catch (e) {
        getProducts = null;
      }
        if (Array.isArray(getProducts) && getProducts.length !== 0) {
          this.goTo("/shopping-cart");
          return;
        }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.title {
  color: $color-on-background;
  height: 46px;
}
.shopping-cart--paragraph {
  width: 382px;
  height: 132px;
  color: #272421;
  line-height: 22px;
}
.para-link {
  font-weight: $font-weight-bold-medium;
  height: 21px;
  cursor: pointer;
  letter-spacing: 0.15px !important;
  color: $color-primary;
}
.para-link:hover {
  text-decoration: underline;
}
.image__dimension {
  box-sizing: border-box;
  // sm -
  @media screen and (max-width: $media-md) {
    width: 100%;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: 371px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: 477px;
  }
}
.empty-cart {
  font-family: 'Futura Std', 'Futura Std', sans-serif !important;
  font-weight: 400;
}
</style>
